var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLixo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36108 0.722195H6.06942L5.87845 0.378445C5.80206 0.225667 5.64928 0.111084 5.4774 0.111084H3.28122C3.10935 0.111084 2.95657 0.225667 2.88018 0.378445L2.70831 0.722195H0.41664C0.244765 0.722195 0.111084 0.874973 0.111084 1.02775V1.63886C0.111084 1.81074 0.244765 1.94442 0.41664 1.94442H8.36108C8.51386 1.94442 8.66664 1.81074 8.66664 1.63886V1.02775C8.66664 0.874973 8.51386 0.722195 8.36108 0.722195ZM1.12324 9.02949C1.14233 9.52602 1.54338 9.88886 2.0399 9.88886H6.71872C7.21525 9.88886 7.61629 9.52602 7.63539 9.02949L8.05553 2.55553H0.722195L1.12324 9.02949Z",
    fill: "#343A40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLixo);
export default __webpack_public_path__ + "static/media/lixo.335448053110cbd1ea8605ba2b5e4036.svg";
export { ForwardRef as ReactComponent };